export class User {
  login_id: string;
  name: string;
  role: string;
  curriculum_id: string;
  birthday: string;
  school_id: string;
  password: string;
  curriculums: Curriculum[] = new Array<Curriculum>();

  constructor(curriculums: any[]){
    curriculums.forEach((x: any) => {
      this.curriculums.push(new Curriculum(x, false));
    });
  }
}

export class Curriculum {
  id: number
  name: string
  is_selected: boolean

  constructor(curriculum: any, is_selected: boolean){
    this.id = curriculum.id;
    this.name = curriculum.name;
    this.is_selected = is_selected;
  }

}